import { inject } from "vue";
import { AWS_RUM_SYMBOL } from "_Main/injectionSymbols";

export function useAwsRumClick(attrs) {
    // Inject the awsRum instance
    const awsRum = inject(AWS_RUM_SYMBOL, null);
    const gtmId = attrs["data-gtmid"];

    // Check if gtmId is defined, not null, not an empty string, and if awsRum is available
    if (gtmId === undefined || gtmId === null || gtmId === "" || !awsRum) {
        return attrs.onClick;
    }

    // since awsRum and gmtId are defined, return the handleClick function that records the event
    return function handleClick(event) {
        // Record the custom event with AWS RUM if it and gtmId are defined
        awsRum.recordEvent("powerclerk.button_event", {
            gtmId: gtmId // Include the id in the event data
        });
        // Call the original onClick handler if it exists
        return attrs.onClick(event);
    };
}
